import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  if (!properties.workflowId) {
    errors.push({ key: 'workflowId', message: 'Workflow ID is required' });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
